import { render, staticRenderFns } from "./MessagePreview.vue?vue&type=template&id=103c34c5&"
import script from "./MessagePreview.vue?vue&type=script&lang=js&"
export * from "./MessagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('103c34c5')) {
      api.createRecord('103c34c5', component.options)
    } else {
      api.reload('103c34c5', component.options)
    }
    module.hot.accept("./MessagePreview.vue?vue&type=template&id=103c34c5&", function () {
      api.rerender('103c34c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/MessagePreview.vue"
export default component.exports